import { createTheme } from '@mantine/core';

// Brand theme. Colors match the navy used in the Phase 1/2/3 PDFs so the
// product surface, the docs, and the marketing site can stay visually aligned.
export const invetrakTheme = createTheme({
  primaryColor: 'invetrak',
  primaryShade: { light: 6, dark: 4 },
  defaultRadius: 'sm',
  fontFamily: 'Segoe UI, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontFamily: 'Segoe UI, -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },
  colors: {
    invetrak: [
      '#e7eef5',
      '#c6d4e1',
      '#a3b9cd',
      '#7e9eba',
      '#5e87a8',
      '#3f7194',
      '#154974',
      '#0e3a5d',
      '#0a3556',
      '#062b48',
    ],
  },
  cursorType: 'pointer',
});
